import { useEffect } from "react";
import { getSharedVariables } from "../variables";

const appPageTitle = getSharedVariables().PAGE_TITLE;

interface UsePageTitleOptions {
  customAppPageTitle?: string;
  disabled?: boolean;
}

const usePageTitle = (pageName: string, options?: UsePageTitleOptions) => {
  const { customAppPageTitle, disabled } = options ?? {};

  useEffect(() => {
    if (disabled) {
      return;
    }

    document.title = pageName
      ? `${pageName} | ${customAppPageTitle || appPageTitle}`
      : customAppPageTitle || appPageTitle;

    return () => {
      document.title = customAppPageTitle || appPageTitle;
    };
  }, [pageName, customAppPageTitle, disabled]);
};

export default usePageTitle;
